import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Session/Login.vue'
import ChangePassword from '../views/Session/ChangePassword.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/login', component: Login,  meta: { requiresAuth: false } },
  { path: '/changepassword', component: ChangePassword,  meta: { requiresAuth: true } },

    
  { path: '/', component: (resolve) => {
      require.ensure(['../views/Dashboard/Index.vue'], () => {
        resolve(require('../views/Dashboard/Index.vue'))
      })
  },  meta: { requiresAuth: true } },
  { path: '/generalinformation', component: (resolve) => {
    require.ensure(['../views/Event/GeneralInformation.vue'], () => {
      resolve(require('../views/Event/GeneralInformation.vue'))
    })
  },  meta: { requiresAuth: true } },
  { path: '/budget', component: (resolve) => {
    require.ensure(['../views/Event/Budget.vue'], () => {
      resolve(require('../views/Event/Budget.vue'))
    })
  },  meta: { requiresAuth: true } },
  { path: '/payment', component: (resolve) => {
    require.ensure(['../views/Event/Payment/Index.vue'], () => {
      resolve(require('../views/Event/Payment/Index.vue'))
    })
  },  meta: { requiresAuth: true } },
  { path: '/catering', component: (resolve) => {
    require.ensure(['../views/Event/Catering/Index.vue'], () => {
      resolve(require('../views/Event/Catering/Index.vue'))
    })
  },  meta: { requiresAuth: true } },
  { path: '/documents', component: (resolve) => {
    require.ensure(['../views/Event/Documents.vue'], () => {
      resolve(require('../views/Event/Documents.vue'))
    })
  },  meta: { requiresAuth: true } },
  { path: '/guests', component: (resolve) => {
    require.ensure(['../views/Event/Guest/Index.vue'], () => {
      resolve(require('../views/Event/Guest/Index.vue'))
    })
  },  meta: { requiresAuth: true } },
  { path: '/photosandvideos', component: (resolve) => {
    require.ensure(['../views/EventMedia/Index.vue'], () => {
      resolve(require('../views/EventMedia/Index.vue'))
    })
  },  meta: { requiresAuth: true } },
  { path: '/appointment', component: (resolve) => {
    require.ensure(['../views/Appointment/Index.vue'], () => {
      resolve(require('../views/Appointment/Index.vue'))
    })
  },  meta: { requiresAuth: true } },
  { path: '*', component: (resolve) => {
      require.ensure(['../views/Error404.vue'], () => {
        resolve(require('../views/Error404.vue'))
      })
  },  meta: { requiresAuth: true } }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js